import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";

import BreadCrumb from "../../BreadCrumb";

import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import {
  addContact,
  editContact,
  updateContact,
} from "../../../store/actions/councilActions/contactActions";

const breadcrumbs = [
  {
    path: "/admin/dashboard",
    label: "Dashboard",
  },
  {
    label: "Add Contact",
  },
];

const AddContact = () => {
  const [loading, setLoading] = useState(false);
  const [exist, setExist] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams();

  const initialState = {
    department: "",
    depart_designation: "",
    name: "",
    phone: "",
  };
  const [data, setData] = useState(initialState);
  const fetchData = async () => {
    setLoading(true);
    const response = await dispatch(editContact(id));
    if (response) {
      setData({
        department: response.department,
        depart_designation: response.depart_designation,
        phone: response.phone,
        name: response.name,
      });
      setLoading(false);
    } else {
      setLoading(false);
      setExist(false);
    }
  };
  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, []);
  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const { name, depart_designation, department, phone } = data;
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (id) {
      const response = await dispatch(
        updateContact({
          ...data,
          enquiry_number_id: id,
        })
      );
      if (response) {
        setData(initialState);
        history.push("/admin/contact/list");
      }
    } else {
      const response = await dispatch(addContact(data));
      if (response) {
        setData(initialState);
        history.push("/admin/contact/list");
      }
    }
  };
  return (
    <div className="row">
      <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
        <div class="subheader py-2 py-lg-6 subheader-solid" id="kt_subheader">
          <div class="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
            <BreadCrumb crumbs={breadcrumbs} />

            <div class="d-flex align-items-center">
              <Link
                to="/admin/contact/list"
                class="btn btn-light-primary font-weight-bolder btn-sm"
              >
                Contact List
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8 card">
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" role="status" size="lg">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : exist ? (
            <>
              <div className="card-header text-center">
                {id ? "Edit Contact" : " Add Contact"}
              </div>
              <div class="myForm">
                <form onSubmit={handleSubmit}>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="boxlabel">
                            <p> Name</p>
                            <input
                              type="text"
                              name="name"
                              value={name}
                              onChange={handleChange}
                              class="form-control"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="boxlabel">
                            <p>Department</p>
                            <input
                              type="text"
                              name="department"
                              value={department}
                              onChange={handleChange}
                              class="form-control"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="boxlabel">
                            <p>Depart Designation</p>
                            <input
                              type="text"
                              name="depart_designation"
                              value={depart_designation}
                              onChange={handleChange}
                              class="form-control"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="boxlabel">
                            <p>Phone</p>
                            <input
                              type="text"
                              name="phone"
                              value={phone}
                              onChange={handleChange}
                              class="form-control"
                              required
                            />
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div
                            class="btn-groups mt-4 text-right"
                            role="group"
                            aria-label="First group"
                          >
                            <button class="btn btn-Next" type="submit">
                              Submit<span></span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </>
          ) : (
            <h5>No Record Found</h5>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddContact;
